import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import FastClick from 'fastclick';
import App from './components/App.jsx';

import {createStore, applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import ReduxPromise from 'redux-promise';
import createLogger from 'redux-logger'; // only for debugin and testing purposes
import thunk from 'redux-thunk';
import reduxMulti from 'redux-multi'
import rootReducer from './modules'

// need to list all style file here
import './styles/lga.scss';
import './styles/myg.scss';
import './styles/dbc.scss';
import './styles/hbc.scss';
import './styles/tgc.scss';
import './styles/sfc.scss';
import './styles/crs.scss';
import './styles/crf.scss';
import './styles/mil.scss';
import './styles/lsc.scss';
import './styles/spt.scss';
import './styles/dlp.scss';
import './styles/dvd.scss';
import './styles/skl.scss';
import './styles/jpl.scss';
import './styles/cbc.scss';

// Client side home app wrapper
function run() {
	// Grab the state from a global injected into server-generated HTML
	const initialState = window.INITIAL_STATE;
	// Create Redux store with initial state
  const logger = createLogger(); // only for debugin and testing purposes
  const createStoreWithMiddleware = applyMiddleware(
    ReduxPromise,
    logger, // only for debugin and testing purposes
    thunk,
    reduxMulti
  )(createStore);
	const store = createStoreWithMiddleware(rootReducer, initialState);

  // Make taps on links and buttons work fast on mobiles
  FastClick.attach(document.body);
  ReactDOM.render(
  	<Provider store={store}>
  		<App />
  	</Provider>,
  	document.getElementById('app'));
  // document.domain = "mysteryguild.com";
}
// Run the application when both DOM is ready
// and page content is loaded
if (window.addEventListener) {
  window.addEventListener('DOMContentLoaded', run);
} else {
  window.attachEvent('onload', run);
}



// WEBPACK FOOTER //
// ./src/app.js